import { IProductCard } from 'models/product/productcard';
import { IStore } from 'redux/IStore';
import { IPage } from 'models/common';
import {
	IProductSearchResultsData,
	IProductSearchResultsAction,
	IProductBaseSearchResultsData,
} from 'models/search/productbasesearchresults';
import { IProductListItemCard } from 'models/product/productlistitem';
import { IProductsResponse } from 'models/product/search/productsResponse';
import { IProductsRequest } from 'models/product/search/productsRequest';
import { IRefinementGroup, IRefinement } from 'models/filtering/refinement';
import { IUserPreferences } from 'models/user/userpreferences';
import { ProductBaseSearch } from '../productBaseSearch';
import * as c from 'models/constants';
import { Likes } from 'redux/modules/user/likes';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { Wishlists } from 'redux/modules/user/wishlists';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
import { SearchUsage } from 'models/enums/searchusage';
import { ProductRefinementGroupings } from '../../../../models';

/** Action Types */
export const REQUEST_START: string = 'productsearchresults/REQUEST_START';
export const REQUEST_FAILURE: string = 'productsearchresults/REQUEST_FAILURE';
export const GET_PRODUCTS_SUCCESS: string = 'productsearchresults/GET_PRODUCTS_SUCCESS';
export const SET_ITEMS_PAGE: string = 'productsearchresults/SET_ITEMS_PAGE';
export const RESET_DATA: string = 'productsearchresults/RESET_DATA';
export const RESET_SEARCH_DATA: string = 'productsearchresults/RESET_SEARCH_DATA';
export const SET_SEARCHED_KEYWORD: string = 'productsearchresults/SET_SEARCHED_KEYWORD';
export const SET_SELECTED_CATEGORY: string = 'productsearchresults/SET_SELECTED_CATEGORY';
export const SET_SORT_ORDER: string = 'productsearchresults/SET_SORT_ORDER';
export const RESET_FILTERS: string = 'productsearchresults/RESET_FILTERS';
export const SET_REFINEMENT_LASTSELECTION: string = 'productsearchresults/SET_REFINEMENT_LASTSELECTION';
export const SET_REFINEMENT_SELECTIONS: string = 'productsearchresults/SET_REFINEMENT_SELECTIONS';
export const SET_REFINEMENT_GROUPS: string = 'productsearchresults/SET_REFINEMENT_GROUPS';
export const SET_REFINEMENT_NARROWSELECTION: string = 'productsearchresults/SET_REFINEMENT_NARROWSELECTION';
export const SET_PRODUCT_SEARCH_RESULTS_FILTERS: string = 'productsearchresults/SET_PRODUCT_SEARCH_RESULTS_FILTERS';
export const LIKE_ITEM_SUCCESS: string = 'productsearchresults/LIKE_ITEM_SUCCESS';
export const LIKE_REQUEST_START: string = 'productsearchresults/LIKE_REQUEST_START';
export const LIKE_REQUEST_FAILURE: string = 'productsearchresults/LIKE_REQUEST_FAILURE';
export const WISHLIST_ITEM_SUCCESS: string = 'productsearchresults/WISHLIST_ITEM_SUCCESS';
export const GET_SELECTED_SEARCHED_PRODUCT_SUCCESS: string =
	'productsearchresults/GET_SELECTED_SEARCHED_PRODUCT_SUCCESS';

/** Initial State */
const initialState: IProductSearchResultsData = {
	items: [],
	isFetching: false,
	isFetchingLikes: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	keyword: null,
	sortOrder: null,
	refinementGroups: [],
	refinementSelections: [],
	lastSelectedRefinementItemId: null,
	lastSelectedRefinementGroupId: null,
	lastActionWasToNarrowRefinement: false,
	selectedCategoryId: null,
	selectedSearchedProduct: null,
};

/** Reducer */
export function productSearchResultsReducer(state = initialState, action: IProductSearchResultsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_PRODUCTS_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				isFetching: false,
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
			});

		case RESET_SEARCH_DATA:
			return Object.assign({}, state, {
				items: [],
				isFetching: false,
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
				sortOrder: null,
				refinementGroups: [],
				refinementSelections: [],
				lastSelectedRefinementItemId: null,
				lastSelectedRefinementGroupId: null,
				lastActionWasToNarrowRefinement: false,
				selectedCategoryId: null,
				selectedSearchedProduct: null,
				keyword: null,
			});

		case SET_SEARCHED_KEYWORD:
			return Object.assign({}, state, {
				keyword: action.payload.keyword,
			});

		case SET_SELECTED_CATEGORY:
			return Object.assign({}, state, {
				selectedCategoryId: action.payload.selectedCategoryId,
			});

		case SET_SORT_ORDER:
			return Object.assign({}, state, {
				sortOrder: action.payload.sortOrder,
				isFirstLoad: true,
			});

		case SET_REFINEMENT_SELECTIONS:
			return Object.assign({}, state, {
				refinementSelections: action.payload.refinementSelections,
			});

		case SET_REFINEMENT_GROUPS:
			return Object.assign({}, state, {
				refinementGroups: action.payload.refinementGroups,
			});

		case SET_REFINEMENT_LASTSELECTION:
			return Object.assign({}, state, {
				lastSelectedRefinementItemId: action.payload.lastSelectedRefinementItemId,
				lastSelectedRefinementGroupId: action.payload.lastSelectedRefinementGroupId,
			});

		case SET_REFINEMENT_NARROWSELECTION:
			return Object.assign({}, state, {
				lastActionWasToNarrowRefinement: action.payload.lastActionWasToNarrowRefinement,
			});

		case WISHLIST_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});

		case GET_SELECTED_SEARCHED_PRODUCT_SUCCESS:
			return Object.assign({}, state, {
				selectedSearchedProduct: action.payload.selectedSearchedProduct,
				isFetching: false,
			});

		case SET_PRODUCT_SEARCH_RESULTS_FILTERS:
			return Object.assign({}, state, {
				refinementGroups: action.payload.refinementGroups,
				refinementSelections: action.payload.refinementSelections,
				lastSelectedRefinementItemId: action.payload.lastSelectedRefinementItemId,
				lastSelectedRefinementGroupId: action.payload.lastSelectedRefinementGroupId,
				lastActionWasToNarrowRefinement: action.payload.lastActionWasToNarrowRefinement,
			});

		case LIKE_REQUEST_START:
			return Object.assign({}, state, {
				isFetchingLikes: true,
			});

		case LIKE_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetchingLikes: false,
			});

		case LIKE_REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetchingLikes: false,
				message: action.payload.message,
				error: true,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getProductSearchResults(isFirstLoad: boolean, isRefinement: boolean, usage: SearchUsage) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
		}

		dispatch(requestStart());

		const state: IProductSearchResultsData = getState().productSearchResults;

		const currentPage: number = state.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = state.itemsPage.itemsPerPage;
		const userPreferences: IUserPreferences = getState().userPreferences;

		const refinementSelections: IRefinementGroup[] = [...state.refinementSelections];
		if (state.refinementGroups && state.refinementGroups.length > 0) {
			refinementSelections.push(state.refinementGroups.find((x) => x.groupId === ProductRefinementGroupings.Price));
		}

		const productsRequest: IProductsRequest = {
			currentPage: newPage,
			itemsPerPage,
			searchKeyword: state.keyword,
			refinementGroups: refinementSelections,
			categoryId: state.selectedCategoryId,
			orderBy: state.sortOrder,
		};

		let method = 'search';
		if (usage === SearchUsage.ProductsSearch) {
			productsRequest.searchKeyword = state.keyword;
		} else if (usage === SearchUsage.ProductsShopCard) {
			productsRequest.published = true;
			productsRequest.groupVariants = true;
			method = 'getbyshop/' + getState().shopcard.shopcard.id;
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/product/' + method,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(productsRequest),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IProductsResponse) => {
						if (isFirstLoad) {
							dispatch(resetData());
						}
						const productSearchResultsState: IProductSearchResultsData = getState().productSearchResults;
						const items: IProductListItemCard[] = productSearchResultsState.items;
						const newItems: IProductListItemCard[] = res.products.items;
						const allItems = [...items, ...newItems];
						dispatch(getProductsSuccess(allItems));
						dispatch(setItemsPage(res.products));

						const pricesRefinementGroup = productSearchResultsState.refinementGroups.find(
							(x) => x.groupId === ProductRefinementGroupings.Price,
						);
						if (pricesRefinementGroup) {
							res.refinementGroups[
								res.refinementGroups.findIndex((x) => x.groupId === ProductRefinementGroupings.Price)
							] = pricesRefinementGroup;
						}

						const likes = new Likes(LikeNodeType.ProductSearch);
						const wishlists = new Wishlists(WishlistNodeType.ProductSearch);
						if (isRefinement) {
							filterOutRefinements(dispatch, res.refinementGroups, productSearchResultsState);
						} else {
							const productBase = new ProductBaseSearch(dispatch, c.NODE_TYPE_PRODUCT, SearchUsage.ProductsShopCard);
							productBase.setInitialRefinementsGroups(res.refinementGroups);
						}
						if (userPreferences && userPreferences.id) {
							dispatch(likes.getLikedItems());
							dispatch(wishlists.getWishlistedItems());
						} else {
							dispatch(likes.updateLikeItems(null));
							dispatch(wishlists.updateWishlistItems(null));
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getSelectedSearchedProduct(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Product/' + id,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IProductCard) => {
						dispatch(getSelectedSearchedProductSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getProductSearchSKUResults(isFirstLoad: boolean, keyword: string) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
		}

		dispatch(requestStart());

		const currentPage: number = getState().productSearchResults.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().productSearchResults.itemsPage.itemsPerPage;

		let queryString = '?';
		if (keyword && keyword !== '') {
			queryString = queryString + 'keyword=' + keyword;
		}
		queryString = queryString + '&CurrentPage=' + newPage;
		queryString = queryString + '&ItemsPerPage=' + itemsPerPage;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Product/Search/SKU' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						const productSearchResultsState: IProductSearchResultsData = getState().productSearchResults;
						const items: IProductListItemCard[] = productSearchResultsState.items;
						const newItems: IProductListItemCard[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getProductsSuccess(items));
						dispatch(setItemsPage(res));
						dispatch(setProductSearchKeyword(keyword));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IProductSearchResultsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getProductsSuccess(items: IProductListItemCard[]): IProductSearchResultsAction {
	return {
		type: GET_PRODUCTS_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IProductSearchResultsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setItemsPage(itemsPage: IPage): IProductSearchResultsAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

/** Action Creator */
export function resetData(): IProductSearchResultsAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function resetSearchData(): IProductSearchResultsAction {
	return {
		type: RESET_SEARCH_DATA,
	};
}

/** Action Creator */
export function setProductSearchKeyword(keyword: string): IProductSearchResultsAction {
	return {
		type: SET_SEARCHED_KEYWORD,
		payload: {
			keyword,
		},
	};
}

/** Action Creator */
export function setProductSelectedCategory(selectedCategoryId: number): IProductSearchResultsAction {
	return {
		type: SET_SELECTED_CATEGORY,
		payload: {
			selectedCategoryId,
		},
	};
}

export function setProductSortOrder(sortOrder: number): IProductSearchResultsAction {
	return {
		type: SET_SORT_ORDER,
		payload: {
			sortOrder,
		},
	};
}

/** Action Creator */
export function setRefinementSelections(refinementSelections: IRefinementGroup[]): IProductSearchResultsAction {
	return {
		type: SET_REFINEMENT_SELECTIONS,
		payload: {
			refinementSelections,
		},
	};
}

/** Action Creator */
export function setRefinementGroups(refinementGroups: IRefinementGroup[]): IProductSearchResultsAction {
	return {
		type: SET_REFINEMENT_GROUPS,
		payload: {
			refinementGroups,
		},
	};
}

/** Action Creator */
export function setLastRefinementItemSelection(
	lastSelectedRefinementItemId: number,
	lastSelectedRefinementGroupId: number,
): IProductSearchResultsAction {
	return {
		type: SET_REFINEMENT_LASTSELECTION,
		payload: {
			lastSelectedRefinementItemId,
			lastSelectedRefinementGroupId,
		},
	};
}

/** Action Creator */
export function setNarrowRefinement(lastActionWasToNarrowRefinement: boolean): IProductSearchResultsAction {
	return {
		type: SET_REFINEMENT_NARROWSELECTION,
		payload: {
			lastActionWasToNarrowRefinement,
		},
	};
}

/** Action Creator */
export function setProductSearchResultsFilters(
	productSearchResultsFilters: IProductBaseSearchResultsData,
): IProductSearchResultsAction {
	return {
		type: SET_PRODUCT_SEARCH_RESULTS_FILTERS,
		payload: {
			refinementGroups: productSearchResultsFilters.refinementGroups,
			refinementSelections: productSearchResultsFilters.refinementSelections,
			lastSelectedRefinementItemId: productSearchResultsFilters.lastSelectedRefinementItemId,
			lastSelectedRefinementGroupId: productSearchResultsFilters.lastSelectedRefinementGroupId,
			lastActionWasToNarrowRefinement: productSearchResultsFilters.lastActionWasToNarrowRefinement,
		},
	};
}

export function wishlistItemSuccess(): IProductSearchResultsAction {
	return {
		type: WISHLIST_ITEM_SUCCESS,
	};
}

/** Action Creator */
export function getSelectedSearchedProductSuccess(selectedSearchedProduct: IProductCard): IProductSearchResultsAction {
	return {
		type: GET_SELECTED_SEARCHED_PRODUCT_SUCCESS,
		payload: {
			selectedSearchedProduct,
		},
	};
}

/** Action Creator */
export function likeItemSuccess(): IProductSearchResultsAction {
	return {
		type: LIKE_ITEM_SUCCESS,
	};
}

/** Action Creator */
export function likeRequestStart(): IProductSearchResultsAction {
	return {
		type: LIKE_REQUEST_START,
	};
}

/** Action Creator */
export function likeRequestFailure(message: any): IProductSearchResultsAction {
	return {
		type: LIKE_REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

//  Method used to work out which refinements to mark as available/disabled/selected
//  based on the list of products that matched the customers last selection.
// ===============================================================
function filterOutRefinements(
	dispatch: any,
	availableRefinementGroups: IRefinementGroup[],
	productSearchResultsState: IProductSearchResultsData,
) {
	const pricesRefinementGroup = productSearchResultsState.refinementGroups.find(
		(x) => x.groupId === ProductRefinementGroupings.Price,
	);

	// groups we get from from api -> all available groups and refinements for search
	const lastSelectedGroup = productSearchResultsState.refinementGroups.filter((obj) => {
		return obj.groupId === productSearchResultsState.lastSelectedRefinementGroupId;
	})[0];
	productSearchResultsState.refinementGroups = availableRefinementGroups; // reset all to api results
	//check if last selected group is in else insert it
	if (
		lastSelectedGroup &&
		productSearchResultsState.refinementGroups.findIndex((x) => x.groupId === lastSelectedGroup.groupId) === -1
	) {
		productSearchResultsState.refinementGroups.push(lastSelectedGroup);
	}
	//check if prices group is in else insert it
	if (
		productSearchResultsState.refinementGroups.findIndex((x) => x.groupId === ProductRefinementGroupings.Price) ===
			-1 &&
		pricesRefinementGroup
	) {
		productSearchResultsState.refinementGroups.push(pricesRefinementGroup);
	}
	productSearchResultsState.refinementGroups.forEach((groupElement: IRefinementGroup) => {
		//restore last selected refinement group but check if all refinements were cleared in this group if so leave reseted to api results!
		const lastSelectedGroupRefinements = productSearchResultsState.refinementSelections.filter((obj) => {
			return obj.groupId === productSearchResultsState.lastSelectedRefinementGroupId;
		});
		if (
			groupElement.groupId === productSearchResultsState.lastSelectedRefinementGroupId &&
			lastSelectedGroupRefinements &&
			lastSelectedGroupRefinements[0] &&
			lastSelectedGroupRefinements[0].refinements.length
		) {
			groupElement.refinements = lastSelectedGroup.refinements;
		}
		//set selections
		groupElement.refinements.forEach((element: IRefinement) => {
			element.available = true;
			element.disabled = false;
			element.selected = false;
			const selectedGroup = productSearchResultsState.refinementSelections.filter((obj) => {
				return obj.groupId === groupElement.groupId;
			});
			if (selectedGroup && selectedGroup.length) {
				const selectedRefinement = selectedGroup[0].refinements.filter((obj) => {
					return obj.id === element.id;
				});
				if (selectedRefinement && selectedRefinement.length) {
					element.selected = true;
					element.available = false;
				}
			}
		});
	});

	const newRefinementGroups = productSearchResultsState.refinementGroups.map((x) => Object.assign({}, x));
	dispatch(setRefinementGroups(newRefinementGroups));
}
